<!-- log-type-icon.component.html -->
<div class="flex items-center justify-start">
  <!-- Apply background color and tooltip -->
  <div
    [ngClass]="getIcon().bgColor"
    [matTooltip]="getIcon().tooltip"
    class="flex items-center p-2 font-mono rounded-lg space-x-1 text-2xs"
    >
    <!-- Apply text color to the mat-icon -->
    <mat-icon [svgIcon]="getIcon().icon" class="w-5 h-5" [ngClass]="getIcon().textColor"></mat-icon>
    <!-- Display label if showLabel is true -->
    @if (showLabel) {
      <span class="lowercase">{{ getIcon().tooltip }}</span>
    }
  </div>
</div>
